<template>
  <section>
    <div class="container-fluid mt-2">
      <h3>{{ $t('DASHBOARD.TITLE') }}</h3>
      <div v-if="1 == 0" class="mb-3">
        <div class="statistics">
          <div class="statistics-icon">
            <i class="fal fa-books" />
          </div>
          <div class="statistics-information">
            <div class="statistics-title">All public documents</div>
            <h3>{{ totalItems }}</h3>
          </div>
        </div>

        <div class="statistics">
          <div class="statistics-icon">
            <i class="fal fa-users" />
          </div>
          <div class="statistics-information">
            <div class="statistics-title">Team documents</div>
            <h3>{{ totalItems }}</h3>
          </div>
        </div>

        <div class="statistics">
          <div class="statistics-icon">
            <i class="fal fa-file-alt" />
          </div>
          <div class="statistics-information">
            <div class="statistics-title">Drafts</div>
            <h3>{{ totalItems }}</h3>
          </div>
        </div>

        <div class="statistics">
          <div class="statistics-icon">
            <i class="fal fa-users" />
          </div>
          <div class="statistics-information">
            <div class="statistics-title">Link requests</div>
            <h3>{{ totalItems }}</h3>
          </div>
        </div>

        <div class="statistics">
          <div class="statistics-icon">
            <i class="fal fa-users" />
          </div>
          <div class="statistics-information">
            <div class="statistics-title">Team members</div>
            <h3>{{ totalItems }}</h3>
          </div>
        </div>
      </div>

      <b-row>
        <b-col cols="12" lg="6" xl="4" md="12">
          <services-list></services-list>          
        </b-col>
        <b-col cols="12" lg="6" xl="4" md="12">
          <team-documents></team-documents>
          <template-documents></template-documents>
        </b-col>
        <b-col cols="12" lg="6" xl="4" md="12">
          <draft-documents></draft-documents>
          <requests></requests>
        </b-col>
      </b-row>
      <online-users></online-users>
    </div>
  </section>
</template>
<script>
import ServicesList from "@/components/Dashboard/ServicesList";
import Requests from "@/components/Dashboard/Requests";
import TeamDocuments from "@/components/Dashboard/TeamDocuments";
import TemplateDocuments from "@/components/Dashboard/TemplateDocuments";
import DraftDocuments from "@/components/Dashboard/DraftDocuments";
import OnlineUsers from "@/components/Dashboard/OnlineUsers";
export default {
  components: {
    ServicesList,
    Requests,
    TeamDocuments,
    TemplateDocuments,
    DraftDocuments,
    OnlineUsers
  },
  data() {
    return {
      totalItems: 0,
      user: this.$store.state.auth.user
    };
  }
};
</script>
<style>
</style>
